import React from 'react';

import { Card } from 'cms/blocks/Amp/AmpCardsBlock';
import { Box } from 'components/Box';
import { gutterWidth } from 'theme';

export function AmpRandomGradProgramsBlockPrograms() {
  return (
    <amp-list
      width="auto"
      height="100"
      layout="fixed-height"
      src="/data/website/random-grad-programs"
      items="gradPrograms"
      max-items="3"
    >
      <template type="amp-mustache">
        <Box
          // @ts-expect-error ts-migrate(2695) FIXME: Left side of comma operator is unused and has no s... Remove this comment to see the full error message
          display={('block', null, 'inline-block')}
          width={[1, null, 1 / 3]}
          verticalAlign="top"
          maxWidth={320}
          px={[0, null, gutterWidth / 2]}
          py={[gutterWidth / 2, null, 0]}
        >
          <Card
            card={{
              image: {
                filename: '{{logo.filename}}',
                handle: '{{logo.handle}}',
                mimetype: '{{logo.mimetype}}',
                size: parseInt('{{logo.size}}', 10),
                source: '{{logo.source}}',
              },
              headline: '{{name}}',
              text: '{{addressCity}}, {{addressState}}',
              label: '{{schoolName}}',
              urls: {
                en: '{{url.en}}',
                es: '{{url.es}}',
                pt: '{{url.pt}}',
              },
            }}
            imageSize="SMALL"
          />
        </Box>
      </template>
    </amp-list>
  );
}
